export function isCurrentCourseEnrollment(enrollment) {
    const course = enrollment?.course;

    if (!course || course.completed === true) {
        return false;
    }

    if (course.in_progress === true && course.is_accessible !== false) {
        return true;
    }

    // Preview window: calendar start is still in the future, but the institution
    // course_preview_buffer allows visibility. is_accessible_to_students is false
    // for staff too, so admins/instructors are not shown far-future courses.
    if (course.is_accessible_to_students === true && course.is_accessible !== false) {
        return true;
    }

    // Legacy fallback when preview attributes are absent.
    if (
        course.is_accessible_to_students === undefined &&
        course.is_accessible === undefined &&
        enrollment.is_active === true
    ) {
        return true;
    }

    return false;
}
